import {
  ChipPassThroughOptions,
  SelectPassThroughAttributes,
  SelectPassThroughOptions,
  SelectPassThroughOptionType,
  TagPassThroughOptions,
} from 'primevue';
import { PassThrough } from '@primevue/core';
import { PassThroughMeridiaInput } from '../../inputs/input/types';
import { PassThroughOptionType } from '../../utils';

export enum SingleSelectType {
  SINGLE = 'single',
  SINGLE_WITH_RADIO = 'single_with_radio',
}

export type PassThroughMeridiaSingleSelect =
  PassThrough<SelectPassThroughOptions> & {
    dropdownIcon?: { class: string };
    header?: SelectPassThroughOptionType;
    filterInput?: PassThroughMeridiaInput;
    value?: PassThroughOptionType<
      SelectPassThroughAttributes,
      {
        value: any;
      }
    >;
    meridiaOption?: PassThroughOptionType<
      SelectPassThroughAttributes,
      {
        option: any;
        selected: boolean;
        index: number;
      }
    >;
    /** Forwarded to the MeridiaChip rendered when `content` is `CHIPS`. */
    chip?: PassThrough<ChipPassThroughOptions>;
    /** Forwarded to the MeridiaTag rendered when `content` is `TAGS`. */
    tag?: PassThrough<TagPassThroughOptions>;
  };
